module.exports = __webpack_public_path__ + "img/Rectangle 2@2x.09286b82.png";